import { X } from "lucide-react";
import { eur } from "../lib/api";
import { PRICING_BASES, SERVICE_TYPES, QTY_FIELDS } from "../lib/labels";
import { Chip, Svc } from "./common";

export function Modal({ title, onClose, children, testid = "modal", wide }) {
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className={`bg-white w-full ${wide ? "sm:max-w-5xl" : "sm:max-w-2xl"} max-h-[92vh] overflow-y-auto rounded-t-2xl sm:rounded-2xl p-5 tl-fade`}
        onClick={(e) => e.stopPropagation()} data-testid={testid}>
        <div className="flex items-center mb-4">
          <h2 className="text-2xl font-bold uppercase">{title}</h2>
          <button className="ml-auto p-2 rounded-full hover:bg-slate-100" onClick={onClose} aria-label="Fermer" data-testid={`${testid}-close`}><X /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function SideCalc({ calc, label, testid }) {
  if (!calc) return null;
  return (
    <div className="border border-slate-200 rounded-xl p-3" data-testid={testid}>
      <div className="flex items-center gap-2 mb-2">
        <span className="font-semibold">{label}</span>
        <span className="ml-auto tl-mono font-semibold" data-testid={`${testid}-total`}>{eur(calc.known_total)}</span>
        {calc.status !== "complet" && <Chip tone="amber">Total incomplet</Chip>}
      </div>
      {calc.components.map((c, i) => (
        <div key={i} className="text-xs border-t border-dashed border-slate-200 pt-1 mt-1">
          <b><Svc type={c.type} /></b> {c.rule_id ? <span className="text-slate-500">· {c.rule_label} v{c.rule_version}</span> : null}
          {c.lines.map((l, j) => (
            <div key={j} className="tl-mono">{PRICING_BASES[l.basis] || l.basis} : {l.qty} × {l.price} = {eur(l.amount)} {l.tier ? `(palier ${l.tier})` : ""}</div>
          ))}
          {c.missing.map((m) => <div key={m} className="text-amber-800">À confirmer — {m}</div>)}
        </div>
      ))}
    </div>
  );
}

export function ComponentsView({ p }) {
  return (
    <div className="space-y-1">
      {p.components.map((c, i) => (
        <div key={i} className="text-sm">
          <b><Svc type={c.type} /></b>
          <span className="text-slate-600"> — {QTY_FIELDS.filter(([k]) => c.qty[k] !== 0).map(([k, l]) => `${l} : ${c.qty[k] ?? "non renseigné"}`).join(" · ") || "quantités nulles"}</span>
          {c.special && <span className="text-slate-600"> · {c.special.destination} {c.special.address} · {c.special.km ?? "?"} km · {c.special.minutes != null ? `${Math.floor(c.special.minutes / 60)}h${String(c.special.minutes % 60).padStart(2, "0")}` : "durée ?"}</span>}
        </div>
      ))}
      {p.auto_observation && <div className="text-xs text-slate-500 italic">{p.auto_observation}</div>}
      {p.observations && <div className="text-xs text-slate-500">Obs. : {p.observations}</div>}
    </div>
  );
}
